var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntelliKeyAppIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    role: "img",
    "aria-label": "IntelliKey",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 240,
    height: 242,
    rx: 64,
    fill: "#087f96"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18,
    width: 216,
    height: 218,
    rx: 54,
    fill: "#faf9fb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#003b49",
    transform: "translate(37 35) scale(5.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.26 27.52c-.45 0-.9-.21-1.2-.6-.5-.66-.37-1.6.29-2.1.99-.75 1.56-1.89 1.56-3.13V10.88c0-2.16-1.76-3.92-3.92-3.92s-3.92 1.76-3.92 3.92v10.81c0 1.24.57 2.38 1.56 3.13.66.5.79 1.44.29 2.1-.5.66-1.44.79-2.1.29-1.75-1.32-2.75-3.33-2.75-5.52V10.88c0-3.81 3.1-6.92 6.92-6.92s6.92 3.1 6.92 6.92v10.81c0 2.19-1 4.21-2.75 5.52-.27.2-.59.3-.9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 27.87c-.74 0-1.34-.6-1.34-1.34v-6.11c0-.74.6-1.34 1.34-1.34s1.34.6 1.34 1.34v6.11c0 .74-.6 1.34-1.34 1.34Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.29,
    r: 1.34
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelliKeyAppIcon);
export default __webpack_public_path__ + "static/media/IntelliKeyAppIcon.4713c9db84c4f16eec1198ac8482f650.svg";
export { ForwardRef as ReactComponent };